/**
 * テスト機能を含むアプリケーションラッパー
 * 開発モードでのみテスト機能を有効にする
 */

'use client';

import React from 'react';
import TestDataPanel from '@/components/test/TestDataPanel';

/**
 * テストラッパープロップス
 */
interface TestWrapperProps {
  children: React.ReactNode;
}

/**
 * 開発環境かどうかを判定する関数
 */
const isDevelopment = () => {
  return process.env.NODE_ENV === 'development';
};

/**
 * テストラッパーコンポーネント
 */
const TestWrapper: React.FC<TestWrapperProps> = ({ children }) => {
  const isDevMode = isDevelopment();
  
  // 本番環境ではテスト機能を使わない
  if (!isDevMode) {
    return <>{children}</>;
  }
  
  // 開発環境ではテスト機能を有効にする
  return (
    <>
      {children}
      <TestDataPanel position="bottom-right" showByDefault={false} />
    </>
  );
};

export default TestWrapper;